const BlockType = require('../../extension-support/block-type');
const ArgumentType = require('../../extension-support/argument-type');
const Cast = require('../../util/cast');
const formatMessage = require('format-message');
const codeGeneration = require('../codeGeneration');
const menuIconURI = "data:image/png;base64,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"

let setupCode = '';
let loopCode = '';
let defineCode = '';
let bodyCode = '';
let definedMotors = new Set();
let definedFunctions = new Set();

class PythonRobo_car {
    constructor(runtime) {
        this.runtime = runtime;
    }

    getInfo() {
        return {
            id: "pythonRoboCar", // Unique ID for the extension
            name: "Python Robo Car", // Display name in the Scratch menu
            menuIconURI: menuIconURI,
            blockIconURI: menuIconURI,
            blocks: [
                {
                    opcode: 'defineMotor',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboCar.defineMotor',
                        default: 'define_motor(motor = [motor])',
                        description: 'Define a motor with two pins and configure them as input or output'
                    }),
                    arguments: {
                        motor: {
                            type: ArgumentType.STRING,
                            menu: 'motorMenu',
                            defaultValue: 'motor1'
                        },
                    }
                },
                {
                    opcode: 'move_car',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboCar.move_car',
                        default: 'move_car_for(direction = [direction], time = [time],speed = [speed])',
                        description: 'import header file'
                    }),
                    arguments: {
                        direction: {
                            type: ArgumentType.STRING,
                            menu: 'directionMenu',
                            defaultValue: 'forward'
                        },
                        time: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1000
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 150
                        }
                    }
                },
                {
                    opcode: 'turn_car',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboCar.turn_car',
                        default: 'turn_car_for(direction = [direction], time = [time],speed = [speed])',
                        description: 'import header file'
                    }),
                    arguments: {
                        direction: {
                            type: ArgumentType.STRING,
                            menu: 'turnDirectionMenu',
                            defaultValue: 'left'
                        },
                        time: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1000
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 150
                        }
                    }
                },
                {
                    opcode: 'rotateAngle',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboCar.clockanticlock',
                        default: 'rotate_car(direction = [clockanticlock], degrees = [degree])',
                        description: 'Turn the robotic car in the specified direction for the given time'
                    }),
                    arguments: {
                        clockanticlock: {
                            type: ArgumentType.STRING,
                            menu: 'clockanticlockMenu',
                            defaultValue: 'clockwise'
                        },
                        degree: {
                            type: ArgumentType.ANGLE,
                            defaultValue: 0
                        }
                    }
                },
                {
                    opcode: 'drawCircle',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboCar.drawCircle',
                        default: 'draw_circle(size = [size])',
                        description: 'Turn the robotic car in the specified direction for the given time'
                    }),
                    arguments: {
                        size: {
                            type: ArgumentType.STRING,
                            menu: 'sizeMenu',
                            defaultValue: 'small'
                        }
                    }
                },
                {
                    opcode: 'stopMovement',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboCar.stopMovement',
                        default: 'stop_moving_for(time = [time])',
                        description: 'Stop all motors for the specified time'
                    }),
                    arguments: {
                        time: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 1000
                        }
                    }
                },
                {
                    opcode: 'moveTowardsDirection',
                    blockType: BlockType.COMMAND,
                    text: 'move_car(direction = [direction], speed = [speed])',
                    arguments: {
                        direction: {
                            type: ArgumentType.STRING,
                            menu: 'directionMenu',
                            defaultValue: 'forward'
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 150
                        }
                    }
                },
                {
                    opcode: 'turnTowardsDirection',
                    blockType: BlockType.COMMAND,
                    text: 'turn_car(direction = [direction], speed = [speed])',
                    arguments: {
                        direction: {
                            type: ArgumentType.STRING,
                            menu: 'turnDirectionMenu',
                            defaultValue: 'left'
                        },
                        speed: {
                            type: ArgumentType.NUMBER,
                            defaultValue: 150
                        }
                    }
                },
                {
                    opcode: 'stopMoving',
                    blockType: BlockType.COMMAND,
                    text: formatMessage({
                        id: 'pythonRoboCar.stopMoving',
                        default: 'stop_moving ( )',
                        description: 'Stop all motors'
                    })
                }
            ],
            menus: {
                numMenu1: {
                    items: ['1', '2', '3', '4']
                },
                motorMenu: {
                    items: ['motor1', 'motor2', 'motor3', 'motor4']
                },
                digitalPortMenu: {
                    items: ['4', '5', '6', '7', '8', '9', '10', '11']
                },
                directionMenu: {
                    items: ['forward', 'backward']
                },
                turnDirectionMenu: {
                    items: ['left', 'right']
                },
                clockanticlockMenu: {
                    items: ['clockwise', 'anticlockwise']
                },
                sizeMenu: {
                    items: ['small', 'medium', 'large']
                }
            }
        };
    }

    accumulateCode() {
        codeGeneration.accumulateCode(defineCode, bodyCode, setupCode, loopCode);
    }

    resetCode() {
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodyCode = '';
    }

    full_reset() {
        setupCode = '';
        loopCode = '';
        defineCode = '';
        bodyCode = '';
        definedMotors.clear();
        definedFunctions.clear();
    }

    defineMotor(args) {
        const motor = args.motor;

        if (definedMotors.has(motor)) {
            return;
        }

        let motorPrefix;
        switch (motor) {
            case 'motor1':
                motorPrefix = 'M1';
                break;
            case 'motor2':
                motorPrefix = 'M2';
                break;
            case 'motor3':
                motorPrefix = 'M3';
                break;
            case 'motor4':
                motorPrefix = 'M4';
                break;
            default:
                console.error('Invalid motor selection.');
                return;
        }
        definedMotors.add(motor);
        this.accumulateCode();
        this.resetCode();
    }

    async move_car(args) {
        const direction = args.direction;
        const time = args.time;
        const speed = args.speed;
        let codeToAdd = '';

        if (direction === 'forward') {
            if (!definedFunctions.has('movefor_time')) {
                bodyCode += `
                void movefor_time(int time, int speed) {
                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, HIGH);digitalWrite(m1b,LOW);' : ''}
                    ${definedMotors.has('motor2') ? 'digitalWrite(m2a, HIGH);digitalWrite(m2b,LOW);' : ''}
                    ${definedMotors.has('motor3') ? 'digitalWrite(m3a, HIGH);digitalWrite(m3b,LOW);' : ''}
                    ${definedMotors.has('motor4') ? 'digitalWrite(m4a, HIGH);digitalWrite(m4b,LOW);' : ''}
                    analogWrite(e1,speed);
  analogWrite(e2,speed);
                    delay(time);
                     analogWrite(e1,0);
  analogWrite(e2,0);
  digitalWrite(m1a, LOW);digitalWrite(m1b,LOW);
                }\n`;
                definedFunctions.add('movefor_time');
            }
            codeToAdd = `movefor_time(${time},${speed});\n`;

            if (typeof window.moveForward === 'function') {
                for (let i = 0; i < time / 100; i++) {
                    window.moveForward();
                    await new Promise(resolve => setTimeout(resolve, 100)); // Add delay of 100ms
                }
                window.stopForward(); // Stop moving after the loop completes
            } else {
                console.error('moveForward function is not available');
            }
        } else if (direction === 'backward') {
            if (!definedFunctions.has('moveback_time')) {
                bodyCode += `
                void moveback_time(int time, int speed) {
                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW);digitalWrite(m1b,HIGH);' : ''}
                    ${definedMotors.has('motor2') ? 'digitalWrite(m2a, LOW);digitalWrite(m2b,HIGH);' : ''}
                    ${definedMotors.has('motor3') ? ' digitalWrite(m3a, LOW);digitalWrite(m3b,HIGH);' : ''}
                    ${definedMotors.has('motor4') ? 'digitalWrite(m4a, LOW);digitalWrite(m4b,HIGH);' : ''}
                   analogWrite(e1,speed);
  analogWrite(e2,speed);
                    delay(time);
                     analogWrite(e1,0);
  analogWrite(e2,0);
  digitalWrite(m1a, LOW);digitalWrite(m1b,LOW);
                }\n`;
                definedFunctions.add('moveback_time');
            }
            codeToAdd = `moveback_time(${time},${speed});\n`;

            if (typeof window.moveBackward === 'function') {
                for (let i = 0; i < time / 100; i++) {
                    window.moveBackward();
                    await new Promise(resolve => setTimeout(resolve, 100)); // Add delay of 100ms
                }
                window.stopBackward(); // Stop moving after the loop completes
            } else {
                console.error('moveBackward function is not available');
            }
        }

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    async turn_car(args) {
        const direction = args.direction;
        const time = args.time;
        const speed = args.speed;
        let codeToAdd = '';

        if (direction === 'left') {
            if (!definedFunctions.has('moveleft_time')) {
            bodyCode += `
            void moveleft_time(int time, int speed) {
                ${definedMotors.has('motor1') ? 'digitalWrite(m1a, HIGH);digitalWrite(m1b,LOW);' : ''}
                ${definedMotors.has('motor2') ? 'digitalWrite(m2a, HIGH);digitalWrite(m2b,LOW);' : ''}
                ${definedMotors.has('motor3') ? 'digitalWrite(m3a, LOW);digitalWrite(m3b,HIGH);' : ''}
                ${definedMotors.has('motor4') ? 'digitalWrite(m4a, LOW);digitalWrite(m4b,HIGH);' : ''}
                analogWrite(e1,speed);
  analogWrite(e2,speed);
                    delay(time);
                     analogWrite(e1,0);
  analogWrite(e2,0);
  digitalWrite(m1a, LOW);digitalWrite(m1b,LOW);
            }\n`;
            definedFunctions.add('moveleft_time');
            }
            codeToAdd = `moveleft_time(${time},${speed});\n`;

            if (typeof window.turnLeft === 'function') {
                for (let i = 0; i < time / 100; i++) {
                    window.turnLeft();
                    await new Promise(resolve => setTimeout(resolve, 100)); // Add delay of 100ms
                }
                window.stopLeft(); // Stop turning after the loop completes
            } else {
                console.error('turnLeft function is not available');
            }
        } else if (direction === 'right') {
            if (!definedFunctions.has('moveright_time')) {
            bodyCode += `
            void moveright_time(int time, int speed) {
                ${definedMotors.has('motor1') ? ' digitalWrite(m1a, LOW);digitalWrite(m1b,HIGH);' : ''}
                ${definedMotors.has('motor2') ? 'digitalWrite(m2a, LOW);digitalWrite(m2b,HIGH);' : ''}
                ${definedMotors.has('motor3') ? 'digitalWrite(m3a, HIGH);digitalWrite(m3b,LOW);' : ''}
                ${definedMotors.has('motor4') ? 'digitalWrite(m4a, HIGH);digitalWrite(m4b,LOW);' : ''}
                analogWrite(e1,speed);
  analogWrite(e2,speed);
                    delay(time);
                     analogWrite(e1,0);
  analogWrite(e2,0);
  digitalWrite(m1a, LOW);digitalWrite(m1b,LOW);
            }\n`;
            definedFunctions.add('moveright_time');
            }
            codeToAdd = `moveright_time(${time},${speed});\n`;

            if (typeof window.turnRight === 'function') {
                for (let i = 0; i < time / 100; i++) {
                    window.turnRight();
                    await new Promise(resolve => setTimeout(resolve, 100)); // Add delay of 100ms
                }
                window.stopRight(); // Stop turning after the loop completes
            } else {
                console.error('turnRight function is not available');
            }
        }

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    async stopMovement(args) {
        const time = args.time;
        if (!definedFunctions.has('movestop_time')) {
            bodyCode += `
            void movestop_time(int time) {
                ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW);digitalWrite(m1b,HIGH);' : ''}
                ${definedMotors.has('motor2') ? 'digitalWrite(m2a, LOW);digitalWrite(m2b,HIGH);' : ''}
                ${definedMotors.has('motor3') ? 'digitalWrite(m3a, HIGH);digitalWrite(m3b,LOW);' : ''}
                ${definedMotors.has('motor4') ? 'digitalWrite(m4a, HIGH);digitalWrite(m4b,LOW);' : ''}
                analogWrite(e1,0);
  analogWrite(e2,0);
                delay(time_);
            }\n`;
            definedFunctions.add('movestop_time');
        }
        if (typeof window.stopForward === 'function' || typeof window.stopBackward === 'function' || typeof window.stopRight === 'function' || typeof window.stopLeft === 'function') {
            for (let i = 0; i < time / 100; i++) {
                window.stopForward();
                window.stopBackward();
                window.stopRight();
                window.stopLeft();
                await new Promise(resolve => setTimeout(resolve, 100)); // Add delay of 100ms
            }
            // Stop moving after the loop completes
        } else {
            console.error('moveBackward function is not available');
        }
        const codeToAdd = `movestop_time(${time});\n`;
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    moveTowardsDirection(args) {
        const direction = args.direction;
        const speed = args.speed;
        let codeToAdd = '';
        if (direction === 'forward') {
            if (!definedFunctions.has('movefor')) {
                bodyCode += `
                void movefor(int speed) {
                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, HIGH); digitalWrite(m1b,LOW);' : ''}
                    ${definedMotors.has('motor2') ? 'digitalWrite(m2a, HIGH); digitalWrite(m2b,LOW);' : ''}
                    ${definedMotors.has('motor3') ? 'digitalWrite(m3a, HIGH); digitalWrite(m3b,LOW);' : ''}
                    ${definedMotors.has('motor4') ? 'digitalWrite(m4a, HIGH); digitalWrite(m4b,LOW);' : ''}
                    analogWrite(e1,speed);
  analogWrite(e2,speed);
                }\n`;
                definedFunctions.add('movefor');
            }
            if (typeof window.moveForward === 'function') {
                window.moveForward();
            } else {
                console.error('moveForward function is not available');
            }
            codeToAdd = `movefor(${speed});\n`;
        } else if (direction === 'backward') {
            if (!definedFunctions.has('moveback')) {
                bodyCode += `
                void moveback(int speed) {
                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW); digitalWrite(m1b,HIGH);' : ''}
                    ${definedMotors.has('motor2') ? 'digitalWrite(m2a, LOW); digitalWrite(m2b,HIGH);' : ''}
                    ${definedMotors.has('motor3') ? 'digitalWrite(m3a, LOW); digitalWrite(m3b,HIGH);' : ''}
                    ${definedMotors.has('motor4') ? 'digitalWrite(m4a, LOW); digitalWrite(m4b,HIGH);' : ''}
                    analogWrite(e1,speed);
  analogWrite(e2,speed);
                }\n`;
                definedFunctions.add('moveback');
            }
            codeToAdd = `moveback(${speed});\n`;
            if (typeof window.moveBackward === 'function') {
                window.moveBackward();
            } else {
                console.error('moveBackward function is not available');
            }
        }

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    turnTowardsDirection(args) {
        const direction = args.direction;
        const speed = args.speed;
        let codeToAdd = '';

        if (direction === 'left') {
            if (!definedFunctions.has('moveleft')) {
                bodyCode += `
                void moveleft(int speed) {
                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, HIGH); digitalWrite(m1b,LOW);' : ''}
                    ${definedMotors.has('motor2') ? 'digitalWrite(m2a, HIGH); digitalWrite(m2b,LOW);' : ''}
                    ${definedMotors.has('motor3') ? 'digitalWrite(m3a, LOW); digitalWrite(m3b,HIGH);' : ''}
                    ${definedMotors.has('motor4') ? 'digitalWrite(m4a, LOW); digitalWrite(m4b,HIGH);' : ''}
                    analogWrite(e1,speed);
  analogWrite(e2,speed);
                }\n`;
                definedFunctions.add('moveleft');
            }
            if (typeof window.turnLeft === 'function') {
                window.turnLeft();
            } else {
                console.error('turnLeft function is not available');
            }
            codeToAdd = `moveleft(${speed});\n`;
        } else if (direction === 'right') {
            if (!definedFunctions.has('moveright')) {
                bodyCode += `
                void moveright(int speed) {
                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW); digitalWrite(m1b,HIGH);' : ''}
                    ${definedMotors.has('motor2') ? 'digitalWrite(m2a, LOW); digitalWrite(m2b,HIGH);' : ''}
                    ${definedMotors.has('motor3') ? 'digitalWrite(m3a, HIGH); digitalWrite(m3b,LOW);' : ''}
                    ${definedMotors.has('motor4') ? 'digitalWrite(m4a, HIGH); digitalWrite(m4b,LOW);' : ''}
                    analogWrite(e1,speed);
  analogWrite(e2,speed);
                }\n`;
                definedFunctions.add('moveright');
            }
            if (typeof window.turnRight === 'function') {
                window.turnRight();
            } else {
                console.error('turnLeft function is not available');
            }
            codeToAdd = `moveright(${speed});\n`;
        }
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    async stopMoving() {
        if (!definedFunctions.has('movestop')) {
            bodyCode += `
            void movestop() {
                ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW); digitalWrite(m1b,LOW);' : ''}
                ${definedMotors.has('motor2') ? 'digitalWrite(m2a, LOW); digitalWrite(m2b,LOW);' : ''}
                ${definedMotors.has('motor3') ? 'digitalWrite(m3a, LOW); digitalWrite(m3b,LOW);' : ''}
                ${definedMotors.has('motor4') ? 'digitalWrite(m4a, LOW); digitalWrite(m4b,LOW);' : ''}
            analogWrite(e1,0);
  analogWrite(e2,0);
                }\n`;
            definedFunctions.add('movestop');
        }
        if (typeof window.stopForward === 'function' || typeof window.stopBackward === 'function' || typeof window.stopRight === 'function' || typeof window.stopLeft === 'function') {
            window.stopForward();
            window.stopBackward();
            window.stopRight();
            window.stopLeft();
        } else {
            console.error('moveForward function is not available');
        }
        const codeToAdd = `movestop();\n`;
        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    rotateAngle(args) {
        const clockanticlock = args.clockanticlock;
        const degree = args.degree;
        let codeToAdd = '';

        if (clockanticlock === 'clockwise') {
            if (!definedFunctions.has('rotateCW')) {
                bodyCode += `
                void rotateCW(float angle) {
                    int rotationTime = calculateRotationTime(angle);

                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW); digitalWrite(m1b,HIGH);' : ''}
                    ${definedMotors.has('motor2') ? 'digitalWrite(m2a, LOW); digitalWrite(m2b,LOW);' : ''}
                    ${definedMotors.has('motor3') ? 'digitalWrite(m3a, LOW); digitalWrite(m3b,LOW);' : ''}
                    ${definedMotors.has('motor4') ? 'digitalWrite(m4a, LOW); digitalWrite(m4b,HIGH);' : ''}
                    analogWrite(e1, 180);
                    analogWrite(e2, 180);

                    delay(rotationTime);

                    analogWrite(e1, 0);
                    analogWrite(e2, 0);
                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW); digitalWrite(m1b,LOW);' : ''}
                }\n`;
                definedFunctions.add('rotateCW');
            }
            codeToAdd = `rotateCW(${degree});\n`;
            
            // if (typeof window.turnRight === 'function') {
            //     window.turnRight();
            //     setTimeout(() => window.stopRight(), degree * 10); // Approximate time based on degree
            // } else {
            //     console.error('turnRight function is not available');
            // }
        } else if (clockanticlock === 'anticlockwise') {
            if (!definedFunctions.has('rotateCCW')) {
                bodyCode += `
                void rotateCCW(float angle) {
                    int rotationTime = calculateRotationTime(angle);

                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW); digitalWrite(m1b,LOW);' : ''}
                    ${definedMotors.has('motor2') ? 'digitalWrite(m2a, LOW); digitalWrite(m2b,HIGH);' : ''}
                    ${definedMotors.has('motor3') ? 'digitalWrite(m3a, LOW); digitalWrite(m3b,HIGH);' : ''}
                    ${definedMotors.has('motor4') ? 'digitalWrite(m4a, LOW); digitalWrite(m4b,LOW);' : ''}
                    analogWrite(e1, 180);
                    analogWrite(e2, 180);

                    delay(rotationTime);

                    analogWrite(e1, 0);
                    analogWrite(e2, 0);
                    ${definedMotors.has('motor1') ? 'digitalWrite(m1a, LOW); digitalWrite(m1b,LOW);' : ''}
                }\n`;
                definedFunctions.add('rotateCCW');
            }
            codeToAdd = `rotateCCW(${degree});\n`;
            
            // if (typeof window.turnLeft === 'function') {
            //     window.turnLeft();
            //     setTimeout(() => window.stopLeft(), degree * 10); // Approximate time based on degree
            // } else {
            //     console.error('turnLeft function is not available');
            // }
        }

        if (localStorage.getItem('codeContext') === 'setup') {
            setupCode += codeToAdd;
        } else if (localStorage.getItem('codeContext') === 'loop') {
            loopCode += codeToAdd;
        }
        this.accumulateCode();
        this.resetCode();
    }
    drawCircle(args) {
        const size = args.size;
    }
}

module.exports = PythonRobo_car;